import { Box } from '@mui/joy';
import React, { PropsWithChildren } from 'react';
import AnimatedGradient from './AnimatedGradient';
import { useSettings } from './providers/SettingsProvider';

export interface SiteWrapperProps extends PropsWithChildren {}

const BLUR = 'blur(0px)';

const SiteWrapper: React.FC<SiteWrapperProps> = ({ children }) => {
  const { settings } = useSettings();

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 'calc(100vh - 2rlh)',
          m: 'var(--layout-inset)',
          mb: 0,
          background: 'white',
          borderRadius: '3px 3px 0 0',
          backdropFilter: BLUR,

          '&::after': {
            content: '""',
            position: 'absolute',
            zIndex: -1,
            inset: 'calc(var(--layout-inset) / -2)',
            bottom: 0,
            mixBlendMode: 'soft-light',
            borderRadius: '5px 5px 0 0 ',
            background: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        {children}
      </Box>
      {settings.showVerticalRhythm && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            top: 'var(--layout-inset)',
            bottom: '-99999999999px',
            zIndex: 1000,
            backgroundImage:
              'linear-gradient(rgba(50, 50, 50, 0.2) 1px, transparent 1px), linear-gradient(rgba(50, 50, 50, 0.1) 1px, transparent 1px)',
            backgroundSize: '100% 1rlh, 100% 0.5rlh',
            pointerEvents: 'none',
          }}
        />
      )}
      <AnimatedGradient />
    </Box>
  );
};

export default SiteWrapper;
